import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { CardBlock } from '@elfsight/widget-ui';
import { useTranslation } from 'react-i18next';
import tinycolor from 'tinycolor2';
import type { Skill } from '../../../../types';

interface SkillsProps {
  items: Skill[];
  isPopup?: boolean;
  color?: string;
  fontSize?: number;
  headlineColor?: string;
  headlineStyle?: TextStyleValue;
}

export const Skills = ({
  items,
  isPopup = false,
  color,
  fontSize,
  headlineStyle,
  headlineColor
}: SkillsProps) => {
  const { t } = useTranslation();

  return (
    <Component>
      {isPopup && (
        <Title
          _fontSize={headlineStyle?.fontSize}
          _fontWeight={headlineStyle?.fontWeight}
          _color={headlineColor}
        >
          {t('Skills')}
        </Title>
      )}

      <SkillsItems>
        {items?.map(
          ({ name, id }) =>
            name && (
              <SkillsItem key={id} _color={color} _fontSize={fontSize}>
                {name}
              </SkillsItem>
            )
        )}
      </SkillsItems>
    </Component>
  );
};

const Component = styled(CardBlock)`
  flex-direction: column;
  align-items: flex-start;
`;
const Title = styled.div<{
  _fontSize?: number;
  _fontWeight?: 'normal' | 'bold' | number;
  _color?: string;
}>`
  font-size: ${({ _fontSize }) => _fontSize && _fontSize * 1.125}px;
  font-weight: ${({ _fontWeight }) => _fontWeight};
  line-height: ${({ _fontSize }) => _fontSize && _fontSize * 1.875}px;
  color: ${({ _color }) => _color};
  margin-bottom: ${({ _fontSize }) => _fontSize && _fontSize * 0.5}px;
`;
const SkillsItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -2px;
`;
const SkillsItem = styled.div<{
  _fontSize?: number;
  _color?: string;
}>`
  margin: 2px;
  padding: ${({ _fontSize }) =>
    _fontSize && `${_fontSize * 0.25}px ${_fontSize * 0.5}px`};
  background-color: ${({ _color }) =>
    tinycolor(_color).setAlpha(0.1).toString()};
  font-size: ${({ _fontSize }) => _fontSize && _fontSize * 0.8125}px;
  line-height: ${({ _fontSize }) => _fontSize}px;
  color: ${({ _color }) => tinycolor(_color).setAlpha(0.7).toString()};
  white-space: nowrap;
  border-radius: 4px;
`;
